import { useState } from 'react';

export const BJJ_BELTS = [
    { key: 'white', label: '화이트', color: '#f4f4f4', text: '#111' },
    { key: 'blue', label: '블루', color: '#2f6df6', text: '#fff' },
    { key: 'purple', label: '퍼플', color: '#8f5bff', text: '#fff' },
    { key: 'brown', label: '브라운', color: '#8a5a35', text: '#fff' },
    { key: 'black', label: '블랙', color: '#111', text: '#fff' },
];

export const beltLabel = key => BJJ_BELTS.find(b => b.key === key)?.label || key || '-';
export const currentBjjPromotion = promotions => [...(promotions || [])]
    .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

function BeltBadge({ promotion }) {
    const belt = BJJ_BELTS.find(b => b.key === promotion?.belt) || BJJ_BELTS[0];
    const stripes = Math.max(0, Math.min(4, +promotion?.stripe || 0));

    return (
        <div className="belt-badge" style={{ background: belt.color, color: belt.text }}>
            <span>{belt.label}</span>
            <div className="belt-rank-bar">
                {Array.from({ length: 4 }, (_, i) => (
                    <i key={i} className={i < stripes ? 'active' : ''} />
                ))}
            </div>
        </div>
    );
}

export default function BjjPromotionSummary({ promotions = [], compact = false }) {
    const [open, setOpen] = useState(false);
    const current = currentBjjPromotion(promotions);
    if (!current) return null;

    return (
        <>
            <div className="stats-section-head">
                <div>
                    <div className="stats-section-title">나의 자격</div>
                    <div className="stats-section-desc">내가 만들어낸 것들</div>
                </div>
            </div>
            <section className={`promotion-summary ${compact ? 'compact' : ''}`}>
                <div>
                    <div className="promotion-eyebrow">현재 주짓수 자격</div>
                    <BeltBadge promotion={current} />
                    <div className="promotion-meta">
                        마지막 승급일 {current.date}
                        {current.place ? ` · ${current.place}` : ''}
                    </div>
                </div>
                <button className="text-link-btn" onClick={() => setOpen(true)}>승급 기록</button>
            </section>

            {open && (
                <div className="confirm-backdrop" onClick={() => setOpen(false)}>
                    <div className="confirm-panel promotion-history-panel" onClick={e => e.stopPropagation()}>
                        <div className="confirm-title">주짓수 승급 기록</div>
                        <div className="promotion-history-list">
                            {[...promotions].sort((a, b) => new Date(b.date) - new Date(a.date)).map(item => (
                                <div key={item.id || `${item.date}-${item.belt}-${item.stripe}`} className="promotion-history-item">
                                    <BeltBadge promotion={item} />
                                    <div>
                                        <strong>{beltLabel(item.belt)} {+item.stripe || 0}그랄</strong>
                                        <span>{item.date}{item.place ? ` · ${item.place}` : ''}</span>
                                        {item.instructor && <span>{item.instructor}에게 승급</span>}
                                        {item.message && <p>{item.message}</p>}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button className="action-btn" onClick={() => setOpen(false)}>닫기</button>
                    </div>
                </div>
            )}
        </>
    );
}
